<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="onClick"
  >
    <path
      class="fill"
      d="M7.50144 3.57803C6.97166 3.57803 6.45378 3.73512 6.01329 4.02945C5.57279 4.32378 5.22947 4.74212 5.02673 5.23157C4.824 5.72102 4.77095 6.2596 4.87431 6.77919C4.97766 7.29879 5.23277 7.77607 5.60738 8.15068C5.98199 8.52529 6.45927 8.7804 6.97887 8.88375C7.49847 8.98711 8.03704 8.93406 8.52649 8.73133C9.01594 8.52859 9.43428 8.18527 9.72861 7.74477C10.0229 7.30428 10.18 6.7864 10.18 6.25662C10.18 5.54622 9.89783 4.8649 9.39549 4.36257C8.89316 3.86023 8.21184 3.57803 7.50144 3.57803ZM7.50144 7.86378C7.18357 7.86378 6.87284 7.76953 6.60855 7.59293C6.34425 7.41633 6.13826 7.16533 6.01661 6.87166C5.89497 6.57799 5.86315 6.25484 5.92516 5.94308C5.98717 5.63133 6.14024 5.34496 6.365 5.12019C6.58977 4.89543 6.87614 4.74236 7.1879 4.68035C7.49965 4.61833 7.8228 4.65016 8.11647 4.7718C8.41014 4.89345 8.66114 5.09944 8.83774 5.36373C9.01434 5.62803 9.1086 5.93876 9.1086 6.25662C9.1086 6.68287 8.93927 7.09166 8.63787 7.39306C8.33647 7.69446 7.92768 7.86378 7.50144 7.86378ZM7.50144 0.363708C5.93908 0.365481 4.44123 0.986909 3.33647 2.09166C2.23172 3.19641 1.61029 4.69427 1.60852 6.25662C1.60852 8.35932 2.58018 10.5879 4.42105 12.702C5.24821 13.6573 6.17918 14.5175 7.19675 15.2668C7.28682 15.3299 7.39414 15.3637 7.50411 15.3637C7.61409 15.3637 7.72141 15.3299 7.81148 15.2668C8.82717 14.5172 9.75633 13.657 10.5818 12.702C12.42 10.5879 13.3944 8.35932 13.3944 6.25662C13.3926 4.69427 12.7712 3.19641 11.6664 2.09166C10.5616 0.986909 9.06379 0.365481 7.50144 0.363708ZM7.50144 14.1585C6.39451 13.2879 2.67996 10.0904 2.67996 6.25662C2.67996 4.97789 3.18794 3.75153 4.09214 2.84733C4.99634 1.94312 6.2227 1.43515 7.50144 1.43515C8.78017 1.43515 10.0065 1.94312 10.9107 2.84733C11.8149 3.75153 12.3229 4.97789 12.3229 6.25662C12.3229 10.089 8.60837 13.2879 7.50144 14.1585Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LocationIcon",
  emits: {
    click: (_payload: MouseEvent) => true,
  },
  setup(_, { emit }) {
    const onClick = (payload: MouseEvent) => emit("click", payload);
    return { onClick };
  },
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
